import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";
import { Virtual } from "swiper/modules";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import VideoCard from "./card";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";

const Wrapper = styled.div`
  position: relative;
  padding: 0 12px;
  margin-bottom: 32px;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0px;
`;

const TitleDash = styled.div`
  background: #dadada;
  height: 1px;
  margin: 4px 0px 8px 0px;
  width: 100%;
`;

const ScrollButton = styled.button`
  position: absolute;
  left: ${(props) => (props.direction === "left" ? "8px" : "auto")};
  right: ${(props) => (props.direction === "right" ? "8px" : "auto")};
  top: 45%;
  transform: translateY(-50%);
  background: #fff;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  z-index: 4;

  svg {
    font-size: 3rem;
    fill: ${({ theme }) => theme.color.dark};
  }

  &:hover {
    opacity: 0.8;
  }
`;

function Button({ direction, isVisible }) {
  const swiper = useSwiper();

  if (!isVisible) return null;

  return (
    <ScrollButton
      direction={direction}
      onClick={() =>
        direction === "right" ? swiper.slideNext() : swiper.slidePrev()
      }
    >
      {direction === "right" ? (
        <KeyboardArrowRightIcon />
      ) : (
        <KeyboardArrowLeftIcon />
      )}
    </ScrollButton>
  );
}

const largeBreakpoints = {
  640: {
    slidesPerView: 2,
    slidesPerGroup: 2,
  },
};

const breakpoints = {
  640: {
    slidesPerView: 2,
    slidesPerGroup: 2,
  },
  900: {
    slidesPerView: 3,
    slidesPerGroup: 3,
  },
  1300: {
    slidesPerView: 4,
    slidesPerGroup: 4,
  },
  1600: {
    slidesPerView: 5,
    slidesPerGroup: 5,
  },
};

function List({ large = false, title, data, handleVideoClick }) {
  const [swiperRef, setSwiperRef] = useState(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const slideTo = (index) => {
    swiperRef.slideTo(index - 1, 0);
  };

  return (
    <Wrapper>
      <Title>{title}</Title>
      <TitleDash />
      <Swiper
        onSwiper={setSwiperRef}
        onSlideChange={(swiper) => {
          setIsBeginning(swiper.isBeginning);
          setIsEnd(swiper.isEnd);
        }}
        modules={[Virtual]}
        spaceBetween={16}
        // slidesPerView={large ? 2 : 5}
        // slidesPerGroup={large ? 2 : 5}
        virtual
        breakpoints={large ? largeBreakpoints : breakpoints}
      >
        {data.map((video, index) => (
          <SwiperSlide key={video.title} virtualIndex={index}>
            <VideoCard
              {...video}
              handleVideoClick={handleVideoClick}
              slideTo={slideTo}
              large={large}
            />
          </SwiperSlide>
        ))}
        {data.length > swiperRef?.params?.slidesPerView && (
          <Button direction="left" isVisible={!isBeginning} />
        )}
        {data.length > swiperRef?.params?.slidesPerView && (
          <Button direction="right" isVisible={!isEnd} />
        )}
      </Swiper>
    </Wrapper>
  );
}

export default List;
